import React from 'react';
import { Badge, Box, Tooltip, HStack, Text } from '@chakra-ui/react';
import { CheckCircleIcon, TimeIcon, ChatIcon, MinusIcon, WarningIcon, CloseIcon, CheckIcon, NotAllowedIcon } from '@chakra-ui/icons';

const statusConfig = {
    aprovado: { color: 'green', icon: <CheckCircleIcon />, text: 'Aprovado', tooltip: 'Item aprovado pelo comprador' },
    parcialmente_aprovado: { color: 'teal', icon: <CheckIcon />, text: 'Parcial', tooltip: 'Aprovado parcialmente (quantidade menor que a solicitada)' },
    rejeitado: { color: 'red', icon: <CloseIcon />, text: 'Rejeitado', tooltip: 'Comprador rejeitou todas as respostas do fornecedor' },
    sem_estoque: { color: 'orange', icon: <WarningIcon />, text: 'Sem Estoque', tooltip: 'Fornecedor declarou furo de estoque' },
    respondido: { color: 'yellow', icon: <ChatIcon />, text: 'Respondido', tooltip: 'Fornecedor respondeu, aguardando aprovação' },
    na_lista: { color: 'blue', icon: <TimeIcon />, text: 'Na Lista', tooltip: 'Item na lista, aguardando resposta do fornecedor' },
    ignorado: { color: 'gray', icon: <NotAllowedIcon />, text: 'Ignorado', tooltip: 'Item marcado para NUNCA entrar em listas de compras (clique para reverter)' },
    sem_status: { color: 'gray', icon: <MinusIcon />, text: 'Sem Lista', tooltip: 'Item ainda não foi para nenhuma lista (clique para escolher ação)' },
};

const ListaCompraStatusBadge = ({ listaCompraStatus, onClickSemLista, renderizar }) => {
    const statusKey = listaCompraStatus?.status || 'sem_status';
    const config = statusConfig[statusKey] || statusConfig.sem_status;
    const listaId = listaCompraStatus?.lista_id;
    const itemListaId = listaCompraStatus?.item_lista_id;

    const abreModal = (statusKey === 'sem_status' || statusKey === 'ignorado') && typeof onClickSemLista === 'function';
    const abreLista = !abreModal && statusKey !== 'sem_status' && statusKey !== 'ignorado' && !!listaId;
    const isClickable = abreModal || abreLista;

    const label = abreLista ? `${config.text} #${listaId}` : config.text;

    const handleClick = (e) => {
        if (!isClickable) return;
        e.stopPropagation();
        if (abreModal) {
            onClickSemLista({ status: statusKey });
            return;
        }
        const url = `/listas-compras/${listaId}${itemListaId ? `#item-${itemListaId}` : ''}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    if (renderizar) {
        return renderizar({ statusKey, scheme: config.color, texto: config.text, listaId, dica: config.tooltip, clicavel: isClickable, onClick: handleClick });
    }

    return (
        <Box mb={1}>
            <Tooltip label={config.tooltip} placement="top" hasArrow>
                <Badge
                    fontSize="10px"
                    colorScheme={config.color}
                    variant="solid"
                    borderRadius="md"
                    cursor={isClickable ? 'pointer' : 'default'}
                    onClick={handleClick}
                    textAlign="center"
                    w="100%"
                >
                    <HStack justify="center" align="center" spacing={1}>
                        {config.icon}
                        <Text as="span" fontSize="8px" fontWeight="bold" isTruncated>
                            {label}
                        </Text>
                    </HStack>
                </Badge>
            </Tooltip>
        </Box>
    );
};

export default ListaCompraStatusBadge;
